"use client";
const e = {
  type: "object",
  properties: {
    aiAnnotations: {
      type: "object",
      properties: {
        answerConfidence: {
          anyOf: [
            {
              type: "string",
              const: "very_confident",
              description: "Very confident"
            },
            {
              type: "string",
              const: "somewhat_confident",
              description: "Somewhat confident"
            },
            {
              type: "string",
              const: "not_confident",
              description: "Not confident"
            },
            {
              type: "string",
              const: "no_sources",
              description: "No Sources"
            },
            {
              type: "string",
              const: "other",
              description: "Other"
            }
          ]
        }
      },
      required: ["answerConfidence"],
      additionalProperties: !0
    }
  },
  required: ["aiAnnotations"],
  additionalProperties: !1
};
export {
  e as escalationSchema
};
